let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8xm0s")).then(() => parcelRequire('1LUW1'));